import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CostAllocationDetail } from '../../../../../../services/data/CostAllocationDetail';
import { isCustomAllocation } from '../../../../../../util/models/costAllocation/cost-allocation-type';

/**
 * Shared component for displaying allocation options in mat-select dropdowns.
 * Used by assign-allocation-dialog, cost-group-dialog, and expert-cost-group-dialog.
 */
@Component({
	selector: 'vex-allocation-option',
	imports: [TranslocoDirective],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './allocation-option.component.html',
})
export class AllocationOptionComponent {
	readonly allocation = input.required<CostAllocationDetail>();

	protected isCustom(): boolean {
		return isCustomAllocation(this.allocation());
	}
}
